import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

import Axios from '@/lib/axios-instance';

type APIPayload = {
  status: boolean;
};

export const toggleLeadSettings = async (payload: APIPayload) => {
  try {
    const response = await Axios.put(
      `/chat_widget_settings/lead_collection/status?status=${payload.status}`,
      {},
    );
    return response.data;
  } catch (error: any) {
    if (error.response) {
      throw new Error(
        `${error.response.data?.meta?.message || 'An error occurred'}`,
      );
    }
    throw new Error(error.message || 'Network Error');
  }
};

export const useToggleLeadSettings = () => {
  const queryClient = useQueryClient();
  return useMutation<ResponseType, Error, APIPayload>({
    mutationFn: (payload) => toggleLeadSettings(payload),
    onSuccess: (data) => {
      toast.success('Lead Settings Updated Successfully');
      queryClient.invalidateQueries({ queryKey: ['get_widget_settings'] });
      console.log(data);
    },
    onError: (error) => {
      toast.error('Lead Settings Update Failed', {
        description: error.message,
      });
    },
  });
};
